module.exports = __webpack_public_path__ + "img/lxtx.4fbdb7dc.gif";